function queryString(obj) {
    let qs = [];
    for (let key in obj) {
        qs.push(`${key}=${obj[key]}`);
    }
    return qs.join("&");
}

// Helper function to parse responses in format "success:XXXX" or parse JSON
function parseResponse(responseText) {
    // First, try to parse as JSON
    try {
        return JSON.parse(responseText);
    } catch (e) {
        // If JSON parsing fails, check if it's the "success:XXXX" format
        if (responseText && typeof responseText === 'string') {
            if (responseText.startsWith('success:')) {
                // Extract order ID from "success:A0121"
                const orderId = responseText.substring('success:'.length);
                return {
                    success: true,
                    orderId: orderId,
                    raw: responseText
                };
            } else if (responseText.startsWith('error:')) {
                // Handle error format
                const errorMsg = responseText.substring('error:'.length);
                return {
                    success: false,
                    error: errorMsg,
                    raw: responseText
                };
            }
        }
        // If we can't parse it, return the raw response
        return responseText;
    }
}

const Request = {
    get(url, params, headers = {}) {
        return new Promise(function (resolve, reject) {
            let qs = params === undefined ? "" : "?" + queryString(params);
            let r = new XMLHttpRequest();

            r.onreadystatechange = function () {
                if (r.readyState === 4) {
                    if (r.status >= 200 && r.status < 405) {
                        const response = parseResponse(r.responseText);
                        resolve(response);
                    } else {
// console.log(r);
                        reject(r.responseText);
                    }
                }
            };

            r.open("GET", `${url}${qs}`, true);

            // Set headers
            for (const [key, value] of Object.entries(headers)) {
                r.setRequestHeader(key, value);
            }

            r.send();
        });
    },    
    getGZipApi(url, params) {
        return new Promise(function (resolve, reject) {
            let qs = params === undefined ? "" : "?" + queryString(params);
            let r = new XMLHttpRequest();
            r.open("GET", `${url}${qs}`, true);

            r.addEventListener('load', function (ev) {
                try {
                    const response = new window.Zlib.Gunzip(new window.Uint8Array(ev.target.response)).decompress();
                    let str = "";
                    for (let i = 0; i < response.byteLength; i++) {
                        str += String.fromCharCode(response[i]);
                    }

                    const res = JSON.parse(str);
                    resolve(res);
                }
                catch (err) {
                    reject({ error: 'outlet' });
                }
            });
            r.responseType = 'arraybuffer';
            r.send();

        });
    },
    post(url, params, headers = {}) {
        return new Promise((resolve, reject) => {
          let r = new XMLHttpRequest();
          r.open("POST", url, true);

          // Set headers
          for (const [key, value] of Object.entries(headers)) {
            r.setRequestHeader(key, value);
          }

          r.onreadystatechange = () => {
            if (r.readyState === 4) {
              if (r.status >= 200 && r.status < 400) {
                const response = parseResponse(r.responseText);
                resolve(response);
              } else {
                console.error("Request failed with status:", r.status, r.responseText);
                reject(r.responseText);
              }
            }
          };

          r.send(params);
        });
      },      
      postJson(url, params, headers = {}) {
        return new Promise(function (resolve, reject) {
            let r = new XMLHttpRequest();
            r.open("POST", url, true);

            // Set headers
            for (const [key, value] of Object.entries(headers)) {
                r.setRequestHeader(key, value);
            }
            r.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

            r.onreadystatechange = function () {
                if (r.readyState === 4) {
                    if (r.status >= 200 && r.status < 400) {
                        const response = parseResponse(r.responseText);
                        resolve(response);
                    } else {
                        console.error("Request failed with status:", r.status, r.responseText);
                        reject(r.responseText);
                    }
                }
            };

            r.send(JSON.stringify(params));
        });
    }    
}
export default Request;
